import { styled } from 'stitches.config'

export const Hr = styled('hr', {
  width: '100%',
  border: 'none',
  borderBottom: '1px solid $accent-gray',
})
